import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { compose } from "redux";
import withEditorProps from "../withEditorProps";
import { withHotkeys } from "@teselagen/ui";
import getCommands from "../commands";
import {
  getCommandHotkeys,
  getCommandHotkeyHandlers,
  HotkeysDialog
} from "@teselagen/ui";
class CommandHotkeyHandler extends React.Component {
  constructor(props) {
    super(props);
    const commands = getCommands(this);
    ["cut", "copy", "paste"].forEach((cmdId) => delete commands[cmdId]);
    this.hotkeyDefs = getCommandHotkeys(commands);
    this.handlers = getCommandHotkeyHandlers(commands);
    this.Handler = withHotkeys(this.hotkeyDefs, this.handlers);
  }
  render() {
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsx(this.Handler, {}, "handla"),
      /* @__PURE__ */ jsx(
        HotkeysDialog,
        {
          dialogTitle: "Editor Hotkeys",
          hotkeySets: {
            Editor: {
              "Search File Menu": this.props.menuSearchHotkey || "cmd+/",
              ...this.hotkeyDefs
            }
          },
          ...this.props.hotkeyDialogProps
        },
        "hotkeyDialog"
      )
    ] });
  }
}
export default compose(withEditorProps)(CommandHotkeyHandler);
